import { Component, OnInit } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";

@Component({
  selector: "ngx-snippet",
  templateUrl: "./snippet.component.html",
  styleUrls: ["./snippet.component.scss"],
})
export class SnippetComponent implements OnInit {
  id: string;
  typ: string = "./thank-you.php";
  formDiv: string = '  <div class="eleads-form"></div>';
  codeSnippet: string = `
  <script id='eleads-root' type='text/javascript'>
    window.el_p = {
      aff_id: "Wnd1kEiIxmaQmBqtcnQlxJpQveQ2",
      id: "HJrkmimdB2qpItpCm191",
      typ: "./thank-you.php"
    };
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    var u = 'https://form.elds.it/eleads-lib.js';
    s.src = u;
    var e = document.getElementById('eleads-root');
    e.parentNode.insertBefore(s, e);
  </script>
  <div class="eleads-form"></div>`;

  constructor(protected dialogRef: NbDialogRef<SnippetComponent>) {}

  async ngOnInit() {
    this.loadSnippet();
  }

  loadSnippet() {
    this.codeSnippet = `
    <script id='eleads-root' type='text/javascript'>
      window.el_p = {
        aff_id: "Wnd1kEiIxmaQmBqtcnQlxJpQveQ2",
        id: "${this.id}",
        typ: "${this.typ}"
      };
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      var u = 'https://form.elds.it/eleads-lib.js';
      s.src = u;
      var e = document.getElementById('eleads-root');
      e.parentNode.insertBefore(s, e);
    </script>
    <div class="eleads-form"></div>
  `;
  }

  close() {
    this.dialogRef.close();
  }
}
